







































































































































































































































import { Initiative } from "@/models/issue";
import { ProjectService } from "@/services/project-service";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "TrackingInitiativeComp",
  components: {},
})
export default class TrackingInitiativeComp extends Vue {
  project_service: ProjectService = new ProjectService();
  initiative = new Array<Initiative>();
  sortBy = "period_total_cost";
  sortDesc = true;
  sortByInner = "id";
  filter = ["", ""];
  fields = [
    { key: "details", label: "", variant: "primary" },
    {
      key: "id",
      class: "font-weight-bold",
      variant: "primary",
      sortable: true,
    },
    {
      key: "subject",
      label: "Name",
      class: "font-weight-bold",
      variant: "primary",
      sortable: true,
    },
    {
      key: "business_unit",
      label: "B. Unit",
      class: "font-weight-bold",
      variant: "primary",
      sortable: true,
    },
    { key: "status", label: "Status", sortable: true },
    { key: "project_name", label: "Operation Project", sortable: true },
    { key: "cap", label: "CAP", sortable: true },
    { key: "total_spent_hours", label: "Total Spent Hours", sortable: true,formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      } },
    { key: "total_cost", label: "Total Cost", sortable: true,formatter: (value: number) => {
        return Vue.filter("currency")(value);
      } },
    {
      key: "period_total_spent_hours",
      label: "Period Spent Hours",
      sortable: true,
      formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      }
    },
    { key: "period_total_cost", label: "Period Cost", sortable: true,formatter: (value: number) => {
        return Vue.filter("currency")(value);
      } },
    { key: "lastBP", label: "Last BP" },
    { key: "lastSDS", label: "Last SDS" },
    { key: "lastSRS", label: "Last SRS" },
  ];
  fieldsBP = [
    { key: "revision", label: "RV" },
    { key: "subject", label: "Name" },
    { key: "status", label: "Status" },
    {
      key: "spent_hours",
      label: "Spent Hours",
      formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      }
    },
    {
      key: "cost",
      label: "Cost",
      formatter: (value: number) => {
        return Vue.filter("currency")(value);
      }
    },
    {
      key: "period_spent_hours",
      label: "Period Spent Hours",
      formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      },
    },
    {
      key: "period_cost",
      label: "Period Cost",
      formatter: (value: number) => {
        return Vue.filter("currency")(value);
      },
    },
    {
      key: "amount",
      label: "Amount",
      formatter: (value: number) => {
        return Vue.filter("currency")(value);
      },
    },
  ];
  fieldsSDS = [
    { key: "revision", label: "RV" },
    { key: "subject", label: "Name" },
    { key: "status", label: "Status" },
    {
      key: "spent_hours",
      label: "Spent Hours",
      formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      },
    },
    {
      key: "cost",
      label: "Cost",
      formatter: (value: number) => {
        return Vue.filter("currency")(value);
      },
    },
    {
      key: "period_spent_hours",
      label: "Period Spent Hours",
      formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      },
    },
    {
      key: "period_cost",
      label: "Period Cost",
      formatter: (value: number) => {
        return Vue.filter("currency")(value);
      },
    },
  ];
  fieldsSRS = [
    { key: "revision", label: "RV" },
    { key: "subject", label: "Name" },
    { key: "status", label: "Status" },
    {
      key: "spent_hours",
      label: "Spent Hours",
      formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      },
    },
    {
      key: "cost",
      label: "Cost",
      formatter: (value: number) => {
        return Vue.filter("currency")(value);
      },
    },
    {
      key: "period_spent_hours",
      label: "Period Spent Hours",
      formatter: (value: number) => {
        return Vue.filter("round")(value,2);
      },
    },
    {
      key: "period_cost",
      label: "Period Cost",
      formatter: (value: number) => {
        return Vue.filter("currency")(value);
      },
    },
  ];
  bpStatuses = [
    { text: "Nuovo", value: 1 },
    { text: "Rifiutato", value: 6 },
    { text: "Variato", value: 9 },
    { text: "Accettato", value: 10 },
  ];
  selectedBpStatuses = new Array<number>();
  alsoClosed = false;
  alsoInactive = false;
  max = new Date();
  min = new Date(2005, 0);
  start = moment().startOf("week").toDate();
  end = new Date(); //default today
  isBusy = false;
  bUnitOptions = [{ text: "Select an option", value: "" }];

  mounted() {
    this.search();
    this.getBUnitOptions();
  }

  getBUnitOptions() {
    this.project_service
      .getProjectsBUnit()
      .then((response) => {
        if (response) {
          response.forEach((s) => {
            this.bUnitOptions.push({ text: s, value: s });
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  search(): void {
    this.isBusy = true;
    const sdate = new Date(this.start);
    const edate = new Date(this.end);
    this.initiative.splice(0, this.initiative.length);
    this.project_service
      .getInitiative(
        this.alsoClosed,
        !this.alsoInactive,
        sdate,
        edate,
        this.filter[0],
        this.filter[1],
        this.selectedBpStatuses
      )
      .then((response) => {
        if (response) {
          response.forEach((i) => {
            this.initiative.push(i);
          });
        }
        this.isBusy = false;
      })
      .catch((error) => {
        console.log(error);
        this.isBusy = false;
      });
  }
}
